<template>
    <LoginContent>
        <div class="row justify-content-center">
            <transition name="fade" mode="out-in">
                <div key="1" class="col-12 col-lg-8 col-xl-8" v-if="!success">
                    <div class="min-height-100vh has-header d-flex align-items-center">
                        <div class="form-content form-team-content w-100 white-content">
                            <div class="h1 mb-4 text-center text-uppercase">{{ $t('login.has_olvidado') }}</div>
                            <div class="mb-4 text-center">{{ $t('login.introduce_email') }}</div>
                            <div class="thumb-container absolute" :style='"background-image: url(" + footer.logo + ")"'></div>
                            <form class="w-100" @submit.prevent="submit">
                                <div class="form-group">
                                    <input type="email" name="email" v-model="login_data.email" :placeholder="$t('formularios.email')"/>
                                </div>
                                <div class="form-group" v-if="mensaje">
                                    <p>{{ this.mensaje }}</p>
                                </div>

                                <ContentOrLoading>
                                    <div class="row justify-content-md-between" v-if="loading == false"> 
                                        <div class="col-12 col-lg-6">
                                            <button type="submit" class="button" name="button">{{ $t('login.enviar') }}</button>
                                        </div>
                                    </div>
                                </ContentOrLoading>                                
                            </form>
                        </div>
                    </div>
                </div>
                <div key="2" class="col-12 col-lg-8 col-xl-8" v-if="success">
                    <div class="d-flex align-items-center">
                        <div class="row w-100 white-content p-3">
                            <div class="col-12">
                                <img class="rounded mx-auto d-block" style="height: 240px;" src="https://storage.compralaentrada.com/images/gif-forgot-password.gif" alt="done"/>
                            </div>
                            <div class="col-12 p-3 text-center">
                                <h4>{{ mensaje }}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div> 
    </LoginContent>
</template>

<script>
    import { config } from '@/config.js';
    import LoginContent from '@/components/frontend/components/LoginContent';
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';

    export default {
        data() {
            return {
                login_data: {},
                mensaje: null,
                loading: false,
                success: false,
                config: config
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            }
        },
        methods: {
            submit() {
                this.loading = true;
                
                this.login_data.filters = {
                    tid : this.configuracion.hash_teatro
                }

                this.$store.dispatch(this.config.getVuexAlias('forgot-password'), this.login_data).then(res => {
                    this.mensaje = res.data.message;
                    this.success = true;
                    this.loading = false;                
                }).catch(error => {
                    this.mensaje = error.response.data.message;
                    this.loading = false;            
                });
                
            }
        },
        components: {
            LoginContent,
            ContentOrLoading
        }
    }
</script>
